import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import YMLogo from "./assets/YMLogo";

export default function Nav2({ rightElement, backButtonOnClick }) {
  const navigate = useNavigate();
  return (
    <nav
      className={`sticky top-0 z-[99] box-border flex max-h-[56px] min-h-[56px] w-full items-center justify-between bg-white px-5 py-0`}
    >
      <div
        onClick={
          backButtonOnClick
            ? backButtonOnClick
            : () => {
                navigate("/");
              }
        }
        className={`cursor-pointer rounded-full p-2.5 hover:bg-white`}
      >
        <FaArrowLeft />
      </div>
      <div
        onClick={() => {
          navigate("/");
        }}
        className="min-w-1/4 flex w-1/4 max-w-[150px] shrink cursor-pointer items-center justify-center "
      >
        <YMLogo fill={"black"} size={56} />
      </div>
      <div className={`w-[40px] rounded-full p-2.5 hover:bg-white`}>
        {rightElement ? rightElement : null}
      </div>
    </nav>
  );
}
